import { ReplaceWhitelistBody, WhitelistItem } from 'multirpc-sdk';

import { mapMultichainToAapiV2 } from '../../utils/mapMultichainToAapiV2';

export interface CreateFilteredWhitelistBodyParams {
  originalWhitelist: WhitelistItem[];
  removedChains: string[];
}

export function createFilteredWhitelistBody(
  params: CreateFilteredWhitelistBodyParams,
): ReplaceWhitelistBody {
  const { originalWhitelist, removedChains } = params;

  // Filter out whitelist items for removed blockchains
  const filteredWhitelist = originalWhitelist.filter(
    item => !removedChains.includes(item.blockchain),
  );

  // Build the replacement whitelist body by preserving the structure
  // and including only the remaining blockchain entries
  return filteredWhitelist.reduce<ReplaceWhitelistBody>(
    (result, item) => {
      const type = item.type as keyof ReplaceWhitelistBody;
      const preparedBlockchain = mapMultichainToAapiV2(item.blockchain);

      result[type] = {
        ...result[type],
        [preparedBlockchain]: [
          ...(result[type][preparedBlockchain] || []),
          ...item.list,
        ],
      };

      return result;
    },
    { address: {}, ip: {}, referer: {} },
  );
}
